import { render, staticRenderFns } from "./VariantDetection.vue?vue&type=template&id=6169d2f0"
import script from "./VariantDetection.vue?vue&type=script&lang=js"
export * from "./VariantDetection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports